import { Button, Dialog, DialogActions, DialogContent, Slide } from '@mui/material'
import React from 'react'
import DialogHeader from './DialogHeader'
import { useTranslation } from 'react-i18next'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DialogOnlyInformation = ({
    onClose,
    titleKey,
    children
}) => {

    const { t } = useTranslation()

    return (
        <Dialog open onClose={onClose} maxWidth={'sm'} TransitionComponent={Transition}>
            <DialogHeader onClose={onClose} titleKey={titleKey} />
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button id='btn-close-dialog-only-information' onClick={onClose}>{t('actions.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}

export default DialogOnlyInformation